import { Tag, Tree, Segmented } from 'antd';

import { Box, Card, styled } from '@mui/material';

const { DirectoryTree } = Tree;

export const TabsStyled = styled(Segmented)`
  margin-bottom: 50px;
  width: max-content;
  .ant-segmented-group {
    height: 35px;
    font-size: 15px;

    .ant-segmented-item {
      display: flex;
      align-items: center;
    }
  }
`;

export const CardStyled = styled(Card)(({ theme }) => ({
  border: `1px solid ${theme.vars.palette.primary.main}`,
  padding: theme.spacing(3),
  minHeight: '73vh',
  height: '100%',
}));

export const DirectoryTreeStyled = styled(DirectoryTree)(({ theme }) => ({
  '.ant-tree-switcher': {
    display: 'none',
  },
}));

export const TreeStyled = styled(Tree)(({ theme }) => ({
  '.ant-tree-treenode': {
    width: '100%',
  },
  '.ant-tree-node-content-wrapper': {
    flex: 1,
    '.ant-checkbox-wrapper': {
      flex: 1,
    },
  },
}));

export const TagStyled = styled(Tag)(({ theme }) => ({
  borderRadius: 5,
  color: `${theme.vars.palette.common.black} !important`,
  padding: '1px 7px',
}));

export const DFlex = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
}));

export const ButtonIcon = styled('span')(({ theme }) => ({
  span: {
    width: '18px',
    height: '18px',
  },
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));

export const IconContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '1px',
}));

export const NoDataContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
}));
